import { atom } from "jotai";

/**
 * Whether the menu still hides categories and offers whose availability window
 * is closed at this hour. Turned off while the browsing channel takes
 * scheduled orders: the menu then belongs to the target window, and an item
 * outside the current hour is shown with its window instead of removed.
 */
export const catalogHoursGateAtom = atom(true);

export default catalogHoursGateAtom;
